import React from "react";
import CompassSvg from "./compassSvg";
import Icon from "@ant-design/icons";

const CompassIcon = (props) => <Icon component={CompassSvg} {...props} />;

export default CompassIcon;
